import React, { Component } from "react";

export default class AdrStatus extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="row">
            <div className="col">
              <span>
                <b>Draft:</b>
              </span>
            </div>
            <div className="col">
              <span>{data ? data.draft : 0}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span>
                <b>Submitted:</b>
              </span>
            </div>
            <div className="col">
              <span>{data ? data.submitted : 0}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span>
                <b>Accepted:</b>
              </span>
            </div>
            <div className="col">
              <span>{data ? data.approved : 0}</span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span>
                <b>Rejected:</b>
              </span>
            </div>
            <div className="col">
              <span>{data ? data.rejected : 0}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
